// extracted by mini-css-extract-plugin
export default {"products_wrapper":"Products_products_wrapper__Y4wlu"};